import { useQuery } from '@tanstack/react-query';
import apiQueryOptions from './apiQueryOptions';

/**
 * useQuery wired to apiRequest: the request is aborted when the query is cancelled,
 * and failures arrive as ApiError so callers can branch on `error.status`.
 * @param queryKey - tanstack query key, ideally built by a per-feature key factory
 * @param request - apiRequest options ({ path, params, method, auth, ... })
 * @param options - any useQuery option (enabled, placeholderData, staleTime, ...),
 *   plus `parse` to read the response body inside the queryFn
 */
export default function useApiQuery(queryKey, request, options = {}) {
  const { parse, ...queryOptions } = options;
  return useQuery({
    ...apiQueryOptions({ queryKey, request, parse }),
    ...queryOptions
  });
}
